$(".ava-product-list .add-cart-btn").click(function(){
  console.log("click");
  var that = $(this);
  that.attr('disabled',true);
//   var count_product_block = $(".product-block ul li").size();
//   if(count_product_block == 9){
//     console.log($(".outer-box ul li").size()+"   "+"==");

//     $("#addToCartFormBuildBox").submit(function(){
      Shopify.queue = [];
//       jQuery('.quantity').each(function() {
        Shopify.queue.push( {
          variantId: $(this).data('variant-id'),
          quantity: 1
        });
//       });
      console.log(Shopify.queue);

      Shopify.addItem = function(variant_id, quantity, callback) {
        var quantity = quantity || 1;
        var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: 'quantity=' + quantity + '&id=' + variant_id,
          dataType: 'json',
          success: function(line_item) { 
            if ((typeof callback) === 'function') {
              callback(line_item);
            }
            else {
              Shopify.onItemAdded(line_item);
            }
          },
          error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(params);
      };       


      Shopify.moveAlong = function() {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);

        }
        // If the queue is empty, we will redirect to the cart page.
        else {
          $.ajax({
            url : '/cart.js',
            type : "GET",
            dataType : "json",
            success : function(data){
              $(".cart-count").html("<a href='/cart'>Cart ("+data['item_count']+")</a>");

            }
          });            

//           $(".cart-count").removeClass("hidden-count");
//           $(".outer-box-li").remove();
//           $(".product-block-li").remove();
          that.attr('disabled',false);
          return false;
        }
      };
      Shopify.moveAlong();
      $('#addToCartFormBuildBox').unbind('submit');

      return false;
    });
//   }
// });
